/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAuthenticateWithSecretDto } from '../models/work-authenticate-with-secret-dto';
import { WorkQrCodeContentDto } from '../models/work-qr-code-content-dto';
import { WorkSendLeadDto } from '../models/work-send-lead-dto';
import { WorkSendMailDto } from '../models/work-send-mail-dto';
import { WorkSendMailFromTemplateDto } from '../models/work-send-mail-from-template-dto';
import { WorkUpdateWelcomescreenDto } from '../models/work-update-welcomescreen-dto';

@Injectable({ providedIn: 'root' })
export class WorkHelpersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `helperV1ControllerSendMail()` */
  static readonly HelperV1ControllerSendMailPath = '/v1/helpers/sendMail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `helperV1ControllerSendMail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerSendMail$Response(
    params: {
      body: WorkSendMailDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkHelpersService.HelperV1ControllerSendMailPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `helperV1ControllerSendMail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerSendMail(
    params: {
      body: WorkSendMailDto
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.helperV1ControllerSendMail$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `helperV1ControllerSendLead()` */
  static readonly HelperV1ControllerSendLeadPath = '/v1/helpers/sendLead';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `helperV1ControllerSendLead()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerSendLead$Response(
    params: {
      body: WorkSendLeadDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkHelpersService.HelperV1ControllerSendLeadPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `helperV1ControllerSendLead$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerSendLead(
    params: {
      body: WorkSendLeadDto
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.helperV1ControllerSendLead$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `helperV1ControllerSendMailFromTemplate()` */
  static readonly HelperV1ControllerSendMailFromTemplatePath = '/v1/helpers/sendMailFromTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `helperV1ControllerSendMailFromTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerSendMailFromTemplate$Response(
    params: {
      body: WorkSendMailFromTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkHelpersService.HelperV1ControllerSendMailFromTemplatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `helperV1ControllerSendMailFromTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerSendMailFromTemplate(
    params: {
      body: WorkSendMailFromTemplateDto
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.helperV1ControllerSendMailFromTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `helperV1ControllerGenerateLatitudeAndLongitudeForAllProjectsGmap()` */
  static readonly HelperV1ControllerGenerateLatitudeAndLongitudeForAllProjectsGmapPath = '/v1/helpers/generateLatitudeAndLongitudeForAllProjects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `helperV1ControllerGenerateLatitudeAndLongitudeForAllProjectsGmap()` instead.
   *
   * This method doesn't expect any request body.
   */
  helperV1ControllerGenerateLatitudeAndLongitudeForAllProjectsGmap$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkHelpersService.HelperV1ControllerGenerateLatitudeAndLongitudeForAllProjectsGmapPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `helperV1ControllerGenerateLatitudeAndLongitudeForAllProjectsGmap$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  helperV1ControllerGenerateLatitudeAndLongitudeForAllProjectsGmap(
    params?: {
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.helperV1ControllerGenerateLatitudeAndLongitudeForAllProjectsGmap$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `helperV1ControllerGenerateQrCode()` */
  static readonly HelperV1ControllerGenerateQrCodePath = '/v1/helpers/generateQrCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `helperV1ControllerGenerateQrCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerGenerateQrCode$Response(
    params: {
      body: WorkQrCodeContentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(this.rootUrl, WorkHelpersService.HelperV1ControllerGenerateQrCodePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `helperV1ControllerGenerateQrCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerGenerateQrCode(
    params: {
      body: WorkQrCodeContentDto
    },
    context?: HttpContext
  ): Observable<string> {
    return this.helperV1ControllerGenerateQrCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `helperV1ControllerGetProjectImportForGoogleAppScripts()` */
  static readonly HelperV1ControllerGetProjectImportForGoogleAppScriptsPath = '/v1/helpers/getProjectImportForGoogleAppScripts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `helperV1ControllerGetProjectImportForGoogleAppScripts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerGetProjectImportForGoogleAppScripts$Response(
    params: {
      body: WorkAuthenticateWithSecretDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkHelpersService.HelperV1ControllerGetProjectImportForGoogleAppScriptsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `helperV1ControllerGetProjectImportForGoogleAppScripts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerGetProjectImportForGoogleAppScripts(
    params: {
      body: WorkAuthenticateWithSecretDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.helperV1ControllerGetProjectImportForGoogleAppScripts$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `helperV1ControllerGetUserImportForGoogleAppScripts()` */
  static readonly HelperV1ControllerGetUserImportForGoogleAppScriptsPath = '/v1/helpers/getUserImportForGoogleAppScripts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `helperV1ControllerGetUserImportForGoogleAppScripts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerGetUserImportForGoogleAppScripts$Response(
    params: {
      department: string;
      active: boolean;
      body: WorkAuthenticateWithSecretDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkHelpersService.HelperV1ControllerGetUserImportForGoogleAppScriptsPath, 'post');
    if (params) {
      rb.query('department', params.department, {});
      rb.query('active', params.active, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `helperV1ControllerGetUserImportForGoogleAppScripts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerGetUserImportForGoogleAppScripts(
    params: {
      department: string;
      active: boolean;
      body: WorkAuthenticateWithSecretDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.helperV1ControllerGetUserImportForGoogleAppScripts$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `helperV1ControllerGetTaskImportForGoogleAppScripts()` */
  static readonly HelperV1ControllerGetTaskImportForGoogleAppScriptsPath = '/v1/helpers/getTaskImportForGoogleAppScripts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `helperV1ControllerGetTaskImportForGoogleAppScripts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerGetTaskImportForGoogleAppScripts$Response(
    params: {
      body: WorkAuthenticateWithSecretDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkHelpersService.HelperV1ControllerGetTaskImportForGoogleAppScriptsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `helperV1ControllerGetTaskImportForGoogleAppScripts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helperV1ControllerGetTaskImportForGoogleAppScripts(
    params: {
      body: WorkAuthenticateWithSecretDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.helperV1ControllerGetTaskImportForGoogleAppScripts$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `helpersViewneoV1ControllerUpdateWelcomescreen()` */
  static readonly HelpersViewneoV1ControllerUpdateWelcomescreenPath = '/v1/helpers/viewneo/updateWelcomescreen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `helpersViewneoV1ControllerUpdateWelcomescreen()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helpersViewneoV1ControllerUpdateWelcomescreen$Response(
    params: {
      body: WorkUpdateWelcomescreenDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkHelpersService.HelpersViewneoV1ControllerUpdateWelcomescreenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `helpersViewneoV1ControllerUpdateWelcomescreen$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  helpersViewneoV1ControllerUpdateWelcomescreen(
    params: {
      body: WorkUpdateWelcomescreenDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.helpersViewneoV1ControllerUpdateWelcomescreen$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
